// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Input_inputBox__srlcE {
  margin-bottom: 12px;
  position: relative;
}
.Input_inputBox__srlcE input {
  display: flex;
  width: 100%;
  height: 40px;
  padding: 11px 30px 11px 30px;
  align-items: center;
  flex-shrink: 0;
  border-radius: 8px;
  border: 1px solid var(--border-secondary);
  background: var(--background-tertiary);
  color: var(--text-primary);
  transition: border 0.3s;
}
.Input_inputBox__srlcE input::placeholder {
  color: var(--text-tertiary);
}
.Input_inputBox__srlcE input:hover {
  border: 1px solid var(--border-hover);
}
.Input_inputBox__srlcE svg {
  position: absolute;
  top: 20px;
  left: 10px;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
}
.Input_inputBox__srlcE svg path {
  stroke-width: 1px;
}

.Input_underlinedInput__lnRdS {
  display: flex;
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid var(--border-secondary, #c8d3e0);
  width: 100%;
  gap: 8px;
  align-self: stretch;
}
.Input_underlinedInput__lnRdS label {
  color: var(--text-secondary, #5c6168);
  width: -moz-fit-content;
  width: fit-content;
  white-space: nowrap;
}
.Input_underlinedInput__lnRdS input {
  padding-left: 0;
  border: none;
  outline: none;
  background: transparent;
}

.Input_underlinedInput__lnRdS {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.Input_btnEye__2bw7g {
  position: absolute;
  right: 0;
  top: 0;
  padding: 20px;
}
.Input_btnEye__2bw7g svg {
  stroke: var(--icon-primary);
  width: 20px;
  height: 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/UI/Forms/Input/Input.module.scss"],"names":[],"mappings":"AAAA;EACC,mBAAA;EACA,kBAAA;AACD;AACC;EACC,aAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,yCAAA;EACA,sCAAA;EACA,0BAAA;EAEA,uBAAA;AAAF;AAEE;EACC,2BAAA;AAAH;AAGE;EACC,qCAAA;AADH;AAKC;EACC,kBAAA;EACA,SAAA;EACA,UAAA;EACA,2BAAA;EAEA,WAAA;EACA,YAAA;AAJF;AAME;EACC,iBAAA;AAJH;;AASA;EACC,aAAA;EACA,mBAAA;EACA,SAAA;EACA,yDAAA;EACA,WAAA;EAEA,QAAA;EACA,mBAAA;AAPD;AASC;EACC,qCAAA;EACA,uBAAA;EAAA,kBAAA;EACA,mBAAA;AAPF;AAUC;EACC,eAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;AARF;;AAYA;EACC,aAAA;EACA,SAAA;EACA,yBAAA;AATD;;AAYA;EACC,kBAAA;EACA,QAAA;EACA,MAAA;EACA,aAAA;AATD;AAWC;EACC,2BAAA;EACA,WAAA;EACA,YAAA;AATF","sourcesContent":[".inputBox {\n\tmargin-bottom: 12px;\n\tposition: relative;\n\n\tinput {\n\t\tdisplay: flex;\n\t\twidth: 100%;\n\t\theight: 40px;\n\t\tpadding: 11px 30px 11px 30px;\n\t\talign-items: center;\n\t\tflex-shrink: 0;\n\t\tborder-radius: 8px;\n\t\tborder: 1px solid var(--border-secondary);\n\t\tbackground: var(--background-tertiary);\n\t\tcolor: var(--text-primary);\n\n\t\ttransition: border 0.3s;\n\n\t\t&::placeholder {\n\t\t\tcolor: var(--text-tertiary);\n\t\t}\n\n\t\t&:hover {\n\t\t\tborder: 1px solid var(--border-hover);\n\t\t}\n\t}\n\n\tsvg {\n\t\tposition: absolute;\n\t\ttop: 20px;\n\t\tleft: 10px;\n\t\ttransform: translateY(-50%);\n\n\t\twidth: 16px;\n\t\theight: 16px;\n\n\t\tpath {\n\t\t\tstroke-width: 1px;\n\t\t}\n\t}\n}\n\n.underlinedInput {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 10px;\n\tborder-bottom: 1px solid var(--border-secondary, #c8d3e0);\n\twidth: 100%;\n\n\tgap: 8px;\n\talign-self: stretch;\n\n\t& label {\n\t\tcolor: var(--text-secondary, #5c6168);\n\t\twidth: fit-content;\n\t\twhite-space: nowrap;\n\t}\n\n\t& input {\n\t\tpadding-left: 0;\n\t\tborder: none;\n\t\toutline: none;\n\t\tbackground: transparent;\n\t}\n}\n\n.underlinedInput {\n\tdisplay: flex;\n\tgap: 10px;\n\tjustify-content: flex-end;\n}\n\n.btnEye {\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\tpadding: 20px;\n\n\tsvg {\n\t\tstroke: var(--icon-primary);\n\t\twidth: 20px;\n\t\theight: 20px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputBox": `Input_inputBox__srlcE`,
	"underlinedInput": `Input_underlinedInput__lnRdS`,
	"btnEye": `Input_btnEye__2bw7g`
};
export default ___CSS_LOADER_EXPORT___;
